import React, {Component} from 'react';

const jQuery = window.jQuery,
	$ = jQuery;

class SearchForm extends Component {

	componentDidMount() {
		$('.search-form-li').on('click', function(e) {
			e.stopPropagation();
			$('.search-form-li').find('#initSearchIcon').addClass('hide');
			$('.search-form-wrap').removeClass('hide').find('input.search').focus();
			$('.main-menu').addClass('hide');
		});

		$(window).on('click', function() {
			$('.search-form-li').find('#initSearchIcon').removeClass('hide');
			$('.search-form-wrap').addClass('hide');
			$('.main-menu').removeClass('hide');
		});
	}

	render() {
		return (
			<li className="search-form-li hide">
				<a id="initSearchIcon">
					<i className="mdi mdi-magnify"/>
				</a>
				<div className="search-form-wrap hide">
					<form action="#">
						<input type="search" className="search"/>
						<button type="submit">
							<i className="mdi mdi-magnify"/>
						</button>
					</form>
				</div>
			</li>
		);
	}
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/elements/SearchForm.js